import { useNavigate } from 'react-router-dom'
import { IconLock } from './components/ui/Icons'

export default function Privacidad() {
  const navigate = useNavigate()
  return (
    <div style={{ minHeight: '100vh', background: '#f9f9fb', fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif' }}>
      {/* Header */}
      <div style={{ background: '#fff', borderBottom: '1px solid #e5e5ea', padding: '0 clamp(16px, 5vw, 80px)' }}>
        <div style={{ maxWidth: 720, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 56 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            <button onClick={() => navigate(-1)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#8e8e93', fontSize: 13, fontFamily: 'inherit', padding: '4px 0' }}>
              ← Volver
            </button>
            <span style={{ color: '#d1d1d6' }}>|</span>
            <span style={{ fontSize: 16, fontWeight: 800, color: '#1c1c1e', letterSpacing: -0.5 }}>Manabi</span>
          </div>
        </div>
      </div>

      <div style={{ maxWidth: 720, margin: '0 auto', padding: '40px clamp(16px, 5vw, 80px) 80px' }}>
        <h1 style={{ fontSize: 28, fontWeight: 800, color: '#1c1c1e', marginBottom: 6, letterSpacing: -0.5 }}>Política de Privacidad</h1>
        <p style={{ fontSize: 13, color: '#8e8e93', marginBottom: 40 }}>Última actualización: junio 2026</p>

        {[
          {
            title: 'Qué datos recopilamos',
            body: 'Recopilamos únicamente los datos que vos nos proporcionás: tu nombre, email, contraseña (cifrada con bcrypt) y los datos cardíacos que capturás con tu sensor (frecuencia cardíaca, variabilidad cardíaca, señal ECG). No recopilamos datos de geolocalización, contactos, ni información de otros dispositivos.',
          },
          {
            title: 'Para qué usamos tus datos',
            body: 'Tus datos cardíacos se almacenan en servidores seguros (Google BigQuery, región us-east) exclusivamente para mostrarte tu propio historial y análisis de salud. Tus datos de acceso se almacenan de forma cifrada para autenticarte en la plataforma.',
          },
          {
            title: 'No compartimos tus datos con terceros',
            body: 'Manabi no vende, alquila ni comparte tus datos personales con terceros de ningún tipo — ni empresas de publicidad, ni aseguradoras, ni laboratorios, ni ninguna otra organización. Tus datos son tuyo y solo vos (y las personas a quienes vos autorices explícitamente) pueden verlos.',
          },
          {
            title: 'Acceso de terceros autorizado por vos',
            body: 'Si usás la función "Compartir acceso", podés autorizar a otra persona (por ejemplo, tu médico o entrenador) a ver tu datos en tiempo real. Este acceso lo controlás vos: podés revocarlo en cualquier momento desde tu perfil.',
          },
          {
            title: 'Almacenamiento y seguridad',
            body: 'Los datos se almacenan en servidores en la nube con encriptación en reposo y en tránsito (HTTPS/TLS). Las contraseñas nunca se almacenan en texto plano — usamos bcrypt con factor de costo alto. Los tokens de sesión tienen vencimiento automático.',
          },
          {
            title: 'Retención de datos',
            body: 'Conservamos tus datos mientras tu cuenta esté activa. Si querés eliminar tu cuenta y todos tus datos, contactanos a privacidad@cagliero.ar y lo procesamos dentro de los 30 días hábiles.',
          },
          {
            title: 'Exportación de datos',
            body: 'Podés exportar todos tus datos en cualquier momento desde la sección Perfil → Mis datos. El archivo descargado en formato JSON contiene todas tus sesiones y lecturas cardíacas.',
          },
          {
            title: 'Cookies y analytics',
            body: 'Manabi no utiliza cookies de rastreo ni herramientas de analytics de terceros. No hay píxeles de Facebook, Google Analytics ni similares.',
          },
          {
            title: 'Menores de edad',
            body: 'Manabi está destinado a personas mayores de 13 años. No recopilamos intencionalmente datos de menores de esa edad.',
          },
          {
            title: 'Cambios a esta política',
            body: 'Si realizamos cambios importantes a esta política, te lo comunicaremos por email con al menos 14 días de anticipación.',
          },
          {
            title: 'Contacto',
            body: 'Para cualquier consulta sobre privacidad, podés escribirnos a privacidad@cagliero.ar.',
          },
        ].map(({ title, body }) => (
          <div key={title} style={{ marginBottom: 28 }}>
            <h2 style={{ fontSize: 16, fontWeight: 700, color: '#1c1c1e', marginBottom: 8 }}>{title}</h2>
            <p style={{ fontSize: 15, color: '#3a3a3c', lineHeight: 1.7 }}>{body}</p>
          </div>
        ))}

        <div style={{ marginTop: 48, padding: '20px 24px', background: '#fff', borderRadius: 16, border: '1px solid #e5e5ea', display: 'flex', alignItems: 'center', gap: 16 }}>
          <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center' }}>
            <IconLock size={28} color="#007aff" />
          </div>
          <div>
            <p style={{ fontSize: 14, fontWeight: 700, color: '#1c1c1e', marginBottom: 3 }}>Tu privacidad es nuestra prioridad</p>
            <p style={{ fontSize: 13, color: '#6c6c70' }}>Tus datos de salud son sensibles. Nos comprometemos a nunca compartirlos con nadie sin tu consentimiento explícito.</p>
          </div>
        </div>
      </div>
    </div>
  )
}
